/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{setId as e}from"../kernel.js";import{IdentityManagerBase as r}from"./IdentityManagerBase.js";const t=new r;e(t);export{t as default};
